<template>
    <p class="product-select-title">
        <slot />
    </p>
</template>

<script>
export default {
    name: 'ProductSelectTitle',
    data() {
        return {};
    },

    props: {},

    computed: {}
};
</script>

<style scoped lang="scss">
.product-select-title {
    text-align: center;
    margin: 25px 0 23px;
    font-size: 16px;
}
</style>
